<template>
  <div class="modal remove">
    <div class="modal__block">
      <p style="white-space: nowrap">Are you sure to
      <span v-if="item.is_active">
        {{ $t('stop') }}
      </span>
      <span v-else>
        {{ $t('start') }}
      </span>
      this link?
      </p>
      <div class="btn__group">
        <button @click="deleteItem">
          <span v-if="item.is_active">
            {{ $t('stop') }}
          </span>
          <span v-else>
            {{ $t('start') }}
          </span>
        </button>
        <button @click="cancel">
          {{ $t('cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ModalRemove',
  props: ['item'],
  data() {
    return {
    }
  },
  methods: {
    deleteItem() {
      console.log('delete');
      let type = (this.item.is_active) ? 'edit_link_stop' : 'edit_link_start'
      this.$emit("remove", {
        removeItem: `${type}_campaign;${this.item.id}`
      });
    },
    cancel() {
      this.$emit("close");
    }
  },
}
</script>